import * as React from 'react';

function SvgLinkedinColour(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <mask
        id="LinkedinColour_svg__a"
        maskUnits="userSpaceOnUse"
        x={2}
        y={2}
        width={26}
        height={26}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2 2.146h25.696v25.696H2V2.146z"
          fill="#fff"
        />
      </mask>
      <g mask="url(#LinkedinColour_svg__a)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M27.696 22.564a5.277 5.277 0 01-5.278 5.278H7.278A5.278 5.278 0 012 22.564V7.424a5.28 5.28 0 015.279-5.278h15.139a5.278 5.278 0 015.278 5.279v15.14z"
          fill="#007BB5"
        />
      </g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.78 5.707a2.235 2.235 0 11-.001 4.473 2.235 2.235 0 010-4.473zM5.85 24.282h3.857V11.874H5.85v12.408zM12.126 11.874h3.699v1.698h.053c.514-.977 1.772-2.004 3.648-2.004 3.905 0 4.626 2.569 4.626 5.909v6.804h-3.855v-6.033c0-1.439-.024-3.29-2.004-3.29-2.006 0-2.313 1.569-2.313 3.187v6.136h-3.854V11.874z"
        fill="#fff"
      />
    </svg>
  );
}

export default SvgLinkedinColour;
